module.exports = __webpack_public_path__ + "img/icon_todown.a5c36de5.png";